import { Calendar, Home, Building2, Mail, CreditCard, DollarSign, UserCircle } from "lucide-react"
import { NavLink } from "react-router-dom"
import { cn } from "@/lib/utils"
import { Button, buttonVariants } from "@/components/ui/button"
import { useSidebar } from "@/components/ui/sidebar"

export function HostSidebar() {
  const { state } = useSidebar()
  const collapsed = state === "collapsed"

  return (
    <div
      className={cn(
        "h-screen border-r bg-white",
        collapsed ? "w-16" : "w-64"
      )}
    >
      <div className="space-y-4 py-4">
        <div className="px-3 py-2">
          <div className="space-y-1">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                cn(
                  "flex items-center rounded-lg px-3 py-2 text-gray-900 transition-all hover:text-gray-900",
                  isActive ? "bg-gray-100" : "hover:bg-gray-100",
                  collapsed && "justify-center"
                )
              }
            >
              <Home className="h-4 w-4" />
              {!collapsed && <span className="ml-3">Dashboard</span>}
            </NavLink>
            <NavLink
              to="/dashboard/events"
              className={({ isActive }) =>
                cn(
                  "flex items-center rounded-lg px-3 py-2 text-gray-900 transition-all hover:text-gray-900",
                  isActive ? "bg-gray-100" : "hover:bg-gray-100",
                  collapsed && "justify-center"
                )
              }
            >
              <Calendar className="h-4 w-4" />
              {!collapsed && <span className="ml-3">Events</span>}
            </NavLink>
            <NavLink
              to="/dashboard/invites"
              className={({ isActive }) =>
                cn(
                  "flex items-center rounded-lg px-3 py-2 text-gray-900 transition-all hover:text-gray-900",
                  isActive ? "bg-gray-100" : "hover:bg-gray-100",
                  collapsed && "justify-center"
                )
              }
            >
              <Mail className="h-4 w-4" />
              {!collapsed && <span className="ml-3">Invites</span>}
            </NavLink>
            <NavLink
              to="/dashboard/organizations"
              className={({ isActive }) =>
                cn(
                  "flex items-center rounded-lg px-3 py-2 text-gray-900 transition-all hover:text-gray-900",
                  isActive ? "bg-gray-100" : "hover:bg-gray-100",
                  collapsed && "justify-center"
                )
              }
            >
              <Building2 className="h-4 w-4" />
              {!collapsed && <span className="ml-3">Organizations</span>}
            </NavLink>
            <NavLink
              to="/dashboard/rate-cards"
              className={({ isActive }) =>
                cn(
                  "flex items-center rounded-lg px-3 py-2 text-gray-900 transition-all hover:text-gray-900",
                  isActive ? "bg-gray-100" : "hover:bg-gray-100",
                  collapsed && "justify-center"
                )
              }
            >
              <CreditCard className="h-4 w-4" />
              {!collapsed && <span className="ml-3">Rate Cards</span>}
            </NavLink>
            <NavLink
              to="/dashboard/profile"
              className={({ isActive }) =>
                cn(
                  "flex items-center rounded-lg px-3 py-2 text-gray-900 transition-all hover:text-gray-900",
                  isActive ? "bg-gray-100" : "hover:bg-gray-100",
                  collapsed && "justify-center"
                )
              }
            >
              <UserCircle className="h-4 w-4" />
              {!collapsed && <span className="ml-3">Profile</span>}
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  )
}